import type * as React from 'react';
import type {TextBlock} from '../../../components/SvgText';
import SvgText from '../../../components/SvgText';
import type {StudentIdCard} from '../../../utils/IdCard';
import Barcode from '../Barcode';
import Matrix from './Matrix';

type Props = {
    idCard: StudentIdCard;
    width: string;
};

const StudentBack: React.FC<Props> = ({idCard, width = '100%'}: Props) => {
    const textColor = idCard.busPass?.textColor ?? '000000';
    const helpTexts = Array.isArray(idCard.helpText) ? idCard.helpText : [idCard.helpText];
    const textBlocks: TextBlock[] = [idCard.instructionText];

    for (const helpText of helpTexts) {
        textBlocks.push('', {style: 'header', content: helpText.header}, helpText.body);
    }

    return (
        <svg viewBox='0 0 1200 800' width={width}>
            <title id={`student-back-${idCard.id}`}>Student Back for ID {idCard.id}</title>
            <defs>
                <clipPath id='card'>
                    <rect x={0} y={0} width={1200} height={800} rx={50} ry={50} />
                </clipPath>
            </defs>

            {idCard.busPass && (
                <rect
                    x={0}
                    y={0}
                    width={1200}
                    height={560}
                    fill={`#${idCard.busPass.fillColor}`}
                    clipPath='url(#card)'
                />
            )}

            <rect x={60} y={60} width={300} height={450} fill='white' />
            <image
                href={`data:image/jpeg;base64,${idCard.photo}`}
                width={300}
                height={450}
                x={60}
                y={60}
            />

            <Barcode idCard={idCard} transform='translate(60, 600)' withoutRoot />

            <SvgText
                blocks={textBlocks}
                x={400}
                y={60}
                fontSize={30}
                width={420}
                fill={`#${textColor}`}
            />

            <Matrix
                x={820}
                y={20}
                title='Late Arrival'
                color={textColor}
                dayNames={idCard.dayNames}
                matrix={idCard.lateArrival}
            />

            <Matrix
                x={820}
                y={270}
                title='Early Release'
                color={textColor}
                dayNames={idCard.dayNames}
                matrix={idCard.earlyRelease}
                omitRowHeader
            />

            {idCard.busPass && (
                <>
                    <rect
                        x={880}
                        y={640}
                        width={280}
                        height={120}
                        rx={20}
                        ry={20}
                        strokeWidth={10}
                        stroke={`#${idCard.busPass.borderColor}`}
                        fill={`#${idCard.busPass.fillColor}`}
                    />
                    <SvgText
                        blocks={['Bus Route', idCard.busPass.text]}
                        x={880 + 280 / 2}
                        y={640 + 120 / 2 - 55}
                        fontSize={50}
                        fontWeight='bold'
                        width={260}
                        textAnchor='middle'
                        fill={`#${idCard.busPass.textColor}`}
                    />
                </>
            )}

            <rect
                x={1}
                y={1}
                width={1200 - 2}
                height={800 - 2}
                rx={50}
                ry={50}
                fill='transparent'
                stroke='#888'
                strokeWidth={2}
            />
        </svg>
    );
};

export default StudentBack;
